import axios from 'axios';
const REST_API_URL_PREFIX = '/karrier/api';

export default {
	getJobs(params) {
		if (params && params.areas) {
			params.areas = params.areas.join(',');
		}

		return axios.get(`${REST_API_URL_PREFIX}/jobs`, { params });
	}
};
